/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();



$('.woobt-item-product .qty-button').on('click', function() {
    let $btn = $(this);
    let $input = $btn.closest('.woobt-item-product').find('input.woobt-qty');
    let currentVal = parseInt($input.val());
    if ($btn.hasClass("woobt-quantity-input-plus")) {
        $input.val(currentVal + 1).trigger('change');
    } 
    else {
        $input.val(currentVal - 1).trigger('change');
    }
});
$('.product-form__add-button').on('click', function(e) {
    e.preventDefault(); // stop normal form submission for now
    
    let $button = $(this);
    let $form = $button.closest('form');
    let variantsToAdd = [];

    // Loop through inputs and collect variant IDs
    $('.woobt-item-product').each(function() {
        let $product = $(this);
        let $checkbox = $product.find('.woobt-checkbox');
        let $qtyInput = $product.find('input.woobt-qty');

        if ($checkbox.is(':checked')) {
            let qty = parseInt($qtyInput.val(), 10);
            if (qty > 0) {
                let variantId = $qtyInput.attr('variantid');
                variantsToAdd.push({
                    id: variantId,
                    quantity: qty
                });
            }
        }
    });

    // Function to add items one by one via AJAX
    function addVariants(index = 0) {
        if (index >= variantsToAdd.length) {
            // After adding all, finally submit main form
            $form.off('submit'); // prevent recursion
            $form.trigger('submit');
            return;
        }

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: variantsToAdd[index].id,
                quantity: variantsToAdd[index].quantity
            },
            dataType: 'json',
            success: function() {
                addVariants(index + 1);
            },
            error: function(err) {
                console.error('Error adding variant:', err);
                addVariants(index + 1); // continue anyway
            }
        });
    }

    if (variantsToAdd.length > 0) {
        addVariants();
    } else {
        // No extra variants, just submit form
        $form.trigger('submit');
    }
});

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
    cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

$(document).on('input', '.numInput-cpc', function() {
 if($(this).val() < 1){
     $(this).val(1);
 }
 calculate();
});

function calculate(){
    var width = $('input[name="properties[Width of wall (m)]"]').val();
    var height = $('input[name="properties[Height of wall (m)]"]').val();
    var areaCovered = parseFloat($('.formula-block label.calculation-element.calc-prop[name="properties[Actual Area (sq m)]"]').attr("data-val"));
    var area = width * height;
    var qtyRequired = Math.ceil(area / areaCovered);
    updatePrice(qtyRequired);
    $('.formula-block label.calculation-element.calc-prop[name="properties[Actual Area (sq m)]"]').text(area.toFixed(2));
    $("#calculation_inp_Actual_Area_sq_m").val(area+" sq meter");
    $("#calculation_inp_Quantity, #qtyCustom").val(qtyRequired);
}
function updatePrice(qty){
    var priceDefault = $("#priceTicker").attr("min");
    var newPrice = Shopify.formatMoney(qty * priceDefault);
    $("#priceTicker").text(newPrice)
}
$('header-cart-drawer .js-close-header-cart').on('click', function() {
    // console.log("hit");
    $(".header-item.header-item--icons .js-close-header-cart").click();
});

if ($(window).width() < 1000) {
    $('.shopify-section-group-header-group .top-bar').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: false,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false
    });
}


